(() => {
  if (window.__auraHotspotsLoaded) return;
  window.__auraHotspotsLoaded = true;

  const mediaSelector = '.product-gallery__media[data-media-id]';
  let frame = 0;
  let previousFocus = null;

  const safeUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url.href : null;
    } catch (_) {
      return null;
    }
  };
  const safeImageUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin || url.hostname === 'cdn.shopify.com' ? url.href : null;
    } catch (_) {
      return null;
    }
  };

  const imageBounds = (image) => {
    const box = image.getBoundingClientRect();
    const iw = image.naturalWidth || box.width;
    const ih = image.naturalHeight || box.height;
    if (!iw || !ih || !box.width || !box.height) return box;
    const fit = getComputedStyle(image).objectFit;
    if (fit !== 'contain' && fit !== 'scale-down') return box;
    const ratio = Math.min(box.width / iw, box.height / ih);
    const width = iw * ratio;
    const height = ih * ratio;
    return { left: box.left + (box.width - width) / 2, top: box.top + (box.height - height) / 2, width, height };
  };

  const positionDots = (overlay, image) => {
    const container = overlay.getBoundingClientRect();
    const bounds = imageBounds(image);
    overlay.querySelectorAll('.aura-hotspots__dot').forEach((dot) => {
      const x = Number(dot.dataset.x);
      const y = Number(dot.dataset.y);
      const invalid = !Number.isFinite(x) || !Number.isFinite(y) || x < 0 || x > 1 || y < 0 || y > 1;
      if (dot.hidden !== invalid) dot.hidden = invalid;
      const size = Number(dot.dataset.size);
      dot.style.setProperty('--aura-dot-size', `${Number.isFinite(size) && size >= 16 && size <= 48 ? Math.round(size) : 20}px`);
      if (dot.hidden) return;
      dot.dataset.tooltipSide = y < .35 ? 'below' : 'above';
      dot.dataset.tooltipAlign = x < .3 ? 'left' : x > .7 ? 'right' : 'center';
      dot.style.left = `${bounds.left - container.left + x * bounds.width}px`;
      dot.style.top = `${bounds.top - container.top + y * bounds.height}px`;
      const color = dot.dataset.color || '';
      dot.style.setProperty('--aura-dot-color', /^#[0-9a-f]{6}$/i.test(color) ? color : '#ffffff');
    });
  };

  const mediaImage = (media) => media.querySelector('img');
  const mediaKey = (src) => {
    try { return new URL(src, location.origin).pathname; } catch (_) { return ''; }
  };

  const syncGallery = () => {
    document.querySelectorAll(`${mediaSelector} .aura-hotspots`).forEach((overlay) => {
      const media = overlay.closest(mediaSelector);
      const image = media && mediaImage(media);
      if (image) positionDots(overlay, image);
    });
  };

  const syncLightbox = () => {
    document.querySelectorAll('.pswp').forEach((pswp) => {
      const slide = pswp.querySelector('.pswp__item--active') || [...pswp.querySelectorAll('.pswp__item')].find((item) => {
        const rect = item.getBoundingClientRect();
        return rect.width > 0 && rect.left <= innerWidth / 2 && rect.right >= innerWidth / 2;
      });
      const image = slide && slide.querySelector('.pswp__img:not(.pswp__img--placeholder)');
      const existing = pswp.querySelector('.aura-hotspots--lightbox');
      if (!slide || !image) { if (existing) existing.remove(); return; }
      const key = mediaKey(image.currentSrc || image.src);
      const source = [...document.querySelectorAll(`${mediaSelector} .aura-hotspots`)].find((overlay) => {
        const galleryImage = mediaImage(overlay.closest(mediaSelector));
        return galleryImage && mediaKey(galleryImage.currentSrc || galleryImage.src) === key;
      });
      if (!source) { if (existing) existing.remove(); return; }
      let overlay = existing;
      if (!overlay || overlay.dataset.auraMediaId !== source.dataset.auraMediaId) {
        if (overlay) overlay.remove();
        overlay = source.cloneNode(true);
        overlay.classList.add('aura-hotspots--lightbox');
        slide.append(overlay);
      } else if (overlay.parentElement !== slide) {
        slide.append(overlay);
      }
      positionDots(overlay, image);
    });
  };

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      syncGallery();
      syncLightbox();
      if (document.querySelector('.pswp')) schedule();
    });
  };

  const dialog = document.createElement('dialog');
  dialog.className = 'aura-hotspots__dialog';
  dialog.innerHTML = '<div class="aura-hotspots__dialog-inner"><button type="button" class="aura-hotspots__close" aria-label="Close Shop the Look">×</button><h2>Shop the Look</h2><img class="aura-hotspots__product-image" alt="" loading="lazy"><p class="aura-hotspots__product-title"></p><p class="aura-hotspots__product-price"></p><a class="aura-hotspots__product-link" href="#">View product and options</a></div>';
  document.body.append(dialog);
  const close = () => { if (dialog.open) dialog.close(); previousFocus?.focus(); };
  dialog.querySelector('.aura-hotspots__close').addEventListener('click', close);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', () => previousFocus?.focus());

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('.aura-hotspots__dot');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    const url = safeUrl(dot.dataset.url);
    if (!url) return;
    previousFocus = dot;
    dialog.querySelector('.aura-hotspots__product-title').textContent = dot.dataset.title || '';
    dialog.querySelector('.aura-hotspots__product-price').textContent = dot.dataset.price || '';
    dialog.querySelector('.aura-hotspots__product-link').href = url;
    const image = dialog.querySelector('.aura-hotspots__product-image');
    const imageUrl = safeImageUrl(dot.dataset.image);
    image.hidden = !imageUrl;
    if (imageUrl) image.src = imageUrl;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('.aura-hotspots__close').focus();
  }, true);

  document.addEventListener('load', schedule, true);
  window.addEventListener('resize', schedule);
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.documentElement);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'hidden'] });
  schedule();
})();
